//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import emptyCell from "../components/emptyCell";
import {getRoomsByMemberId} from "../../api/newOwner";
import {getDeliveryRooms} from "../../api/delivery";

export default {
    name: "order",
    components: {
        emptyCell,
    },
    data() {
        return {
            leftIco: require('@/assets/img/ico-building.png'),
            pageIndex: 1,
            pageSize: 20,
            refreshing: false,
            loading: false,
            finished: false,
            list: [],
            deliveryRooms: [],
            rooms: [],
            searchInput: {},
            memberInfo: {}
        }
    },
    methods: {
        getDeliveryRecords() {
            this.searchInput.memberId = this.memberInfo.id;
            this.searchInput.maxResultCount = 20;
            this.searchInput.skipCount = 0;
            abp.ajax.post('/api/services/app/DeliveryRecord/SearchDeliveryRecords', this.searchInput).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
                // this.totalCount = res.data.result.totalCount;
            }).finally(() => {
                // this.loading = false;
            });
        },

        getMyMember() {
            const vm = this;
            this.$store.dispatch({
                type: 'member/getMyMember'
            }).then(() => {
                vm.memberInfo = this.$store.state.member.memberInfo;
                vm.getDeliveryRooms();
                // vm.getRooms();
                vm.getDeliveryRecords();
            });
        },
        deliverOrder(item) {
            // console.log(item.status)
            // if (item.status === 0 || item.status === 10 || item.status === 11) {
                this.$router.push({path: '/deliverOrder/' + item.recordId})
            // }
            // else {
            //     this.$router.push({
            //         name: 'my-appointDetail',
            //         params: {
            //             id: item.recordId
            //         }
            //     })
            // }
        },

        getRooms() {
            const vm = this;
            getRoomsByMemberId(vm.memberInfo.id).then(res => {
                this.rooms = [];
                this.rooms.push(...res.data.result);
            }).finally(() => {
            });
        },

        getDeliveryRooms() {
            getDeliveryRooms().then(res => {
                this.deliveryRooms = [];
                this.deliveryRooms.push(...res.data.result)
            }).finally(() => {

            })
        }
        // getOrders() {
        //     if (!localStorage.getItem('Select-ProjectId') || parseInt(localStorage.getItem('Select-ProjectId')) <= 0) {
        //         return
        //     }
        //     this.refreshing = this.pageIndex === 1;
        //     this.loading = this.pageIndex > 1;
        //     let params = {
        //         status: 1,
        //         projectId: localStorage.getItem('Select-ProjectId'),
        //         filter: '',
        //         sorting: '',
        //         maxResultCount: this.pageSize,
        //         skipCount: (this.pageIndex - 1) * this.pageSize
        //     };
        //     abp.ajax.post('/api/services/app/Delivery/SearchDeliveryPlans', params)
        //         .then(res => {
        //             // console.log('items：%@', res.data.result.items);
        //             if (this.pageIndex === 1) {
        //                 this.list = [];
        //             }
        //             this.list.push(...res.data.result.items);
        //             if (res.data.result.items.length < this.pageSize) {
        //                 this.finished = true;
        //             }
        //         })
        //         .catch(() => {
        //         })
        //         .then(() => {
        //             this.refreshing = false;
        //             this.loading = false;
        //         });
        // },

    },
    created() {
        this.getMyMember();
        // this.getDeliveryRecords();
        // this.getOrders();
    }
}
